import { controls, currencyToNumber, grouped } from "../../controls";


const validate_ac = {
  label: "Validate Accounts",
  starting: true,
  url: "validate_ac",
  pageLabel: "Validate Accounts",
  pageType: "history",
  filter: [


    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Branch", defaultValue: "assigned_branch", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "branch_display" }),

    
    ...controls.displayText({ tab: "filter", label: "Limit" }),
    ...controls.numberOnly({ tab: "filter",name:"account_limit",  fastpath: "limit" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),

  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Validate accounts",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Uploaded Account Number",
        accessor: "uploaded_account_number",
      },
      {
        Header: "Uploaded Account Name",
        accessor: "uploaded_account_name",
      },
      {
        Header: "Customer Number",
        accessor: "customer_number",
      },
      {
        Header: "Customer Name",
        accessor: "customer_name",
      }
    ]
  }
};

export default validate_ac;